export const HEADING_CLASS_NAME = 'RTE_h';
export const PARAGRAPGH_CLASS_NAME = 'RTE_p';
export const BOLD_CLASS_NAME = 'RTE_b';
export const UNORDERED_LIST_CLASS_NAME = 'RTE_ul';
export const ORDERED_LIST_CLASS_NAME = 'RTE_ol';
export const LIST_ITEM_CLASS_NAME = 'RTE_li';
export const LINK_CLASS_NAME = 'RTE_a';
export const IMAGE_CLASS_NAME = 'RTE_img';
